import { getCountriesDictSelector } from '@Store/selectors/dictionarySelector';
import { CountryDict } from 'types';
import { useAppSelector } from '.';

interface ReturnedValue {
  findCountryType: (requestTypeId: number) => CountryDict | undefined;
}

const useFindCountryTypeByType = (): ReturnedValue => {
  const dictionary = useAppSelector(getCountriesDictSelector);

  const findCountryType = (requestTypeId: number): CountryDict | undefined =>
    dictionary.find((item) => item.id === requestTypeId);

  return { findCountryType };
};

export default useFindCountryTypeByType;
